import React, { useEffect, useState } from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import { TextSkeleton } from "../../../interfaccia/loading";
import { isAnnullata, messaggioErrore } from "./kitModaApi";

const LUNGHEZZA_MINIMA = 2;
const ATTESA_MS = 300;

/**
 * Ricerca di un articolo Moda per codVS, codice produttore o nome.
 * Ogni nuova digitazione annulla la ricerca precedente: solo l'ultima aggiorna i risultati.
 */
function RicercaArticoloKit({ api, onSelect, escludi = [], autoFocus = true }) {
  const [testo, setTesto] = useState("");
  const [risultati, setRisultati] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const query = testo.trim();
    setError("");
    if (query.length < LUNGHEZZA_MINIMA) {
      setRisultati(null);
      setLoading(false);
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const data = await api.cerca(query, controller.signal);
        if (!controller.signal.aborted) setRisultati(data);
      } catch (err) {
        if (controller.signal.aborted || isAnnullata(err)) return;
        setError(messaggioErrore(err, "Ricerca non riuscita"));
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, ATTESA_MS);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [api, testo]);

  const esclusi = new Set(escludi);

  return (
    <div>
      <label className="db mb2 b" htmlFor="kitModaRicercaArticolo">
        Cerca l'articolo per codVS, codice produttore o nome
      </label>
      <input
        id="kitModaRicercaArticolo"
        type="search"
        className={stilePulsanti.inputClassesNoMeasure}
        value={testo}
        onChange={(event) => setTesto(event.target.value)}
        autoFocus={autoFocus}
        autoComplete="off"
      />
      {error && (
        <p className="mt0 dark-red" role="alert">
          {error}
        </p>
      )}
      {loading && !risultati && <TextSkeleton lines={3} lineHeight={16} />}
      {risultati && risultati.length === 0 && !loading && (
        <p className="mt0 scrittaColMedio">Nessun articolo trovato.</p>
      )}
      {risultati && risultati.length > 0 && (
        <ul className="list pl0 mt0 kitModaRisultati" aria-label="Articoli trovati">
          {risultati.map((articolo) => {
            const escluso = esclusi.has(articolo.codVS);
            return (
              <li key={articolo.codVS} className="bb bordoColAlt">
                <button
                  type="button"
                  className="kitModaRisultato w-100 tl pv2 ph1 bn bg-transparent pointer"
                  onClick={() => onSelect(articolo)}
                  disabled={escluso}
                  aria-label={`Scegli ${articolo.codVS} ${articolo.nome}`}
                >
                  <span className="b">{articolo.codVS}</span>
                  {articolo.codProd ? <span className="scrittaColMedio"> · {articolo.codProd}</span> : null}
                  <span className="db">
                    {articolo.nome}
                    {articolo.nomeColore ? ` · ${articolo.nomeColore}` : ""}
                  </span>
                  {!articolo.idPs && (
                    <span className="db f7 dark-red">Non risulta su Prestashop Viglietti: Tembo potrebbe rifiutarlo</span>
                  )}
                  {escluso && <span className="db f7 scrittaColMedio">Già nel kit</span>}
                </button>
              </li>
            );
          })}
        </ul>
      )}
      {risultati && risultati.length === 20 && (
        <p className="mt1 f7 scrittaColMedio">Mostro i primi 20 risultati: affina la ricerca se non trovi l'articolo.</p>
      )}
    </div>
  );
}

export default RicercaArticoloKit;
